import { TEAMS_COLLECTION, UPLOADED_FILES_COLLECTION } from '../../../constants'
import { FirestoreClient, UploadedFile } from '../../../types'
import { FirestoreAdmin } from '../../../types/FirestoreAdmin'

interface Props<T extends FirestoreClient | FirestoreAdmin> {
  firestore: T
  teamId: string
}

export const getUploadedFilesRef = <
  T extends FirestoreClient | FirestoreAdmin
>({
  firestore,
  teamId,
}: Props<T>): T extends FirestoreClient
  ? firebase.firestore.CollectionReference<UploadedFile>
  : FirebaseFirestore.CollectionReference => {
  return firestore
    .collection(TEAMS_COLLECTION)
    .doc(teamId)
    .collection(UPLOADED_FILES_COLLECTION) as any
}
